import { EnumSchema } from '../metadata-schema';

export const OnderbouwsnelheidUitzondering: EnumSchema = {
	"type": "string",
	"title": "OnderbouwsnelheidUitzondering",
	"enum": [
		"Reguliere onderbouwsnelheid",
		"Geen onderbouw",
		"Geen 1-oktoberplaatsing",
		"Tussentijdse instroom",
		"Uitgesloten van ROD-communicatie",
		"Emigratie",
		"Uitstroom speciaal onderwijs",
		"Uitstroom/Geen VO",
		"Internationale leerling",
		"PrO-leerling",
		"VAVO leerling",
		"Nieuwkomer"
	]
};
